<template>
  <v-form
    ref="form"
    v-model="isValid"
    class="onboarding-stepper-form"
    @submit.prevent=""
  >
    <slot />

    <div class="onboarding-stepper-form__stepper-controls">
      <DsButton
        v-if="step > 1 && !concluded"
        class="onboarding-stepper-form__stepper-buttons"
        color="secondary"
        @click="previousStep"
      >
        {{ previousButton }}
      </DsButton>

      <DsButton
        v-if="!concluded"
        class="onboarding-stepper-form__stepper-buttons"
        color="primary"
        :disabled="!isValid"
        @click="nextStep"
      >
        {{ nextButton }}
      </DsButton>

      <DsButton
        v-if="concluded"
        class="onboarding-stepper-form__stepper-buttons"
        color="primary"
        @click="stepperProcessing"
      >
        {{ $t('components.Onboarding.label.button.lastButtonLabel') }}
      </DsButton>
    </div>
  </v-form>
</template>

<script>
import { DsButton } from '@ds/components';

export default {
  name: 'OnboardingStepperForm',
  components: {
    DsButton,
  },
  props: {
    concluded: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
    nextStep: {
      type: Function,
      default: () => this.step++,
    },
    previousStep: {
      type: Function,
      default: () => this.step--,
    },
    stepperProcessing: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      isValid: false,
    };
  },
  computed: {
    nextButton() {
      return this.$t('components.Onboarding.label.button.nextButton');
    },
    previousButton() {
      return this.$t('components.Onboarding.label.button.previousButton');
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-stepper-form {
    &__stepper-controls {
      margin-top: 48px;
    }

    &__stepper-buttons {
      margin-right: var(--ds-spacing-stack-xs);
    }
  }
</style>
